export enum AppType {
  cvWebtempNo = "cvWebtempNo",
  iframe = "iframe",
}
